/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuCategoriesDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-categories-dto';

export interface GetMenuCategoriesForAreaLayout$Params {
  servingAreaId: string;
}

export function getMenuCategoriesForAreaLayout(http: HttpClient, rootUrl: string, params: GetMenuCategoriesForAreaLayout$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuCategoriesForAreaLayout.PATH, 'get');
  if (params) {
    rb.path('servingAreaId', params.servingAreaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>;
    })
  );
}

getMenuCategoriesForAreaLayout.PATH = '/api/menu-categories/layouts/{servingAreaId}';
